<script setup lang="ts">
  import type { IconProps } from '../../types/icon'
  import type { ConcreteComponent } from 'vue'
  import { markRaw, ref, watch } from 'vue'

  import alert from './svg/alert.svg?component'
  import alert1 from './svg/alert-1.svg?component'
  import arrow2left from './svg/arrow-2-left.svg?component'
  import arrow2right from './svg/arrow-2-right.svg?component'
  import arrowLeft from './svg/arrow-left.svg?component'
  import arrowRight from './svg/arrow-right.svg?component'
  import at from './svg/at.svg?component'
  import calendar from './svg/calendar.svg?component'
  import check from './svg/check.svg?component'
  import copy from './svg/copy.svg?component'
  import deleteIcon from './svg/delete.svg?component'
  import desktop from './svg/desktop.svg?component'
  import discount from './svg/discount.svg?component'
  import dollar from './svg/dollar.svg?component'
  import download from './svg/download.svg?component'
  import duplicate from './svg/duplicate.svg?component'
  import euro from './svg/euro.svg?component'
  import eye from './svg/eye.svg?component'
  import filter from './svg/filter.svg?component'
  import help from './svg/help.svg?component'
  import home from './svg/home.svg?component'
  import horizontalDote from './svg/horizontal-dote.svg?component'
  import image from './svg/image.svg?component'
  import lineArrowCurveUpLeft from './svg/line-arrow-curve-up-left.svg?component'
  import link from './svg/link.svg?component'
  import linkShare from './svg/link-share.svg?component'
  import loader from './svg/loader.svg?component'
  import loading from './svg/loading.svg?component'
  import logout from './svg/logout.svg?component'
  import mobile from './svg/mobile.svg?component'
  import pause from './svg/pause.svg?component'
  import play from './svg/play.svg?component'
  import plus from './svg/plus.svg?component'
  import pound from './svg/pound.svg?component'
  import search from './svg/search.svg?component'
  import settings from './svg/settings.svg?component'
  import stop from './svg/stop.svg?component'
  import trash from './svg/trash.svg?component'
  import upload from './svg/upload.svg?component'
  import userCircle from './svg/user-circle.svg?component'
  import verticalDote from './svg/vertical-dote.svg?component'
  import voucher from './svg/voucher.svg?component'
  import user from './svg/user.svg?component'
  import cross from './svg/cross.svg?component'

  const iconsMap = new Map<string, ConcreteComponent>()

  iconsMap.set('alert', markRaw(alert))
  iconsMap.set('alert-1', markRaw(alert1))
  iconsMap.set('arrow-2-left', markRaw(arrow2left))
  iconsMap.set('arrow-2-right', markRaw(arrow2right))
  iconsMap.set('arrow-left', markRaw(arrowLeft))
  iconsMap.set('arrow-right', markRaw(arrowRight))
  iconsMap.set('at', markRaw(at))
  iconsMap.set('calendar', markRaw(calendar))
  iconsMap.set('check', markRaw(check))
  iconsMap.set('copy', markRaw(copy))
  iconsMap.set('cross', markRaw(cross))
  iconsMap.set('delete', markRaw(deleteIcon))
  iconsMap.set('desktop', markRaw(desktop))
  iconsMap.set('discount', markRaw(discount))
  iconsMap.set('dollar', markRaw(dollar))
  iconsMap.set('download', markRaw(download))
  iconsMap.set('duplicate', markRaw(duplicate))
  iconsMap.set('euro', markRaw(euro))
  iconsMap.set('eye', markRaw(eye))
  iconsMap.set('filter', markRaw(filter))
  iconsMap.set('help', markRaw(help))
  iconsMap.set('home', markRaw(home))
  iconsMap.set('horizontal-dote', markRaw(horizontalDote))
  iconsMap.set('image', markRaw(image))
  iconsMap.set('line-arrow-curve-up-left', markRaw(lineArrowCurveUpLeft))
  iconsMap.set('link', markRaw(link))
  iconsMap.set('link-share', markRaw(linkShare))
  iconsMap.set('loader', markRaw(loader))
  iconsMap.set('loading', markRaw(loading))
  iconsMap.set('logout', markRaw(logout))
  iconsMap.set('mobile', markRaw(mobile))
  iconsMap.set('pause', markRaw(pause))
  iconsMap.set('play', markRaw(play))
  iconsMap.set('plus', markRaw(plus))
  iconsMap.set('pound', markRaw(pound))
  iconsMap.set('search', markRaw(search))
  iconsMap.set('settings', markRaw(settings))
  iconsMap.set('stop', markRaw(stop))
  iconsMap.set('trash', markRaw(trash))
  iconsMap.set('upload', markRaw(upload))
  iconsMap.set('user', markRaw(user))
  iconsMap.set('user-circle', markRaw(userCircle))
  iconsMap.set('vertical-dote', markRaw(verticalDote))
  iconsMap.set('voucher', markRaw(voucher))

  const props = defineProps<IconProps>()

  const icon = ref<ConcreteComponent | undefined>(undefined)

  watch(
    () => props.name,
    (name) => {
      icon.value = iconsMap.get(name)
    },
    { immediate: true }
  )
</script>

<template>
  <component :is="icon" />
</template>
